import { render } from "./SMSSetupModal.vue?vue&type=template&id=3c87817a&scoped=true"
import script from "./SMSSetupModal.vue?vue&type=script&lang=js"
export * from "./SMSSetupModal.vue?vue&type=script&lang=js"

import "./SMSSetupModal.vue?vue&type=style&index=0&id=3c87817a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c87817a"]])

export default __exports__